module.exports = __webpack_public_path__ + "img/wheel_HIGH_win.87827a82.png";